"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M12.632 19.33c.3.304.544.834.093 1.361-.45.527-1.128.278-1.345 0l-8.695-8.264a.735.735 0 0 1 0-.975l8.695-8.087c.246-.267.8-.605 1.345-.117.545.488.153 1.16-.093 1.428l-6.743 7.32 6.743 7.334Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M21.632 19.33c.3.304.544.834.093 1.361-.45.527-1.128.278-1.345 0l-8.695-8.264a.735.735 0 0 1 0-.975l8.695-8.087c.246-.267.8-.605 1.345-.117.545.488.153 1.16-.093 1.428l-6.743 7.32 6.743 7.334Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};